// extracted by mini-css-extract-plugin
module.exports = {"registrationTitle":"_3bV_cQE4PACDaPy1KwKtAj","registrationContainer":"j70cLN5siMKPcij3IzLDw","formDivider":"_3ZsAbPdfMESJOgEj5SweTG"};